// @flow
import React from 'react';
import { Spin } from 'antd';

import { LoadingWrap } from './style';

const Loading = () => (
  <LoadingWrap>
    <Spin />
  </LoadingWrap>
);

export default Loading;
